import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
}
const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const getMembershipInvoice = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_membership_invoice/`
    );
    return data;
  } catch (error) {
    return error;
  }
};
const getEventInvoice = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_event_invoice/`
    );
    return data;
  } catch (error) {
    return error;
  }
};
const editPayment = async (paymentId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/update_payment/`,
      paymentId
    );
    return data;
  } catch (error) {}
};

const getMembershipInvoiceInfo = async (paymentId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_membership_invoice_info/`,
      paymentId
    );
    return data;
  } catch (error) {}
};

const getInvoiceNote = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_membership_invoice_notes/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getMemberFees = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_member_fees/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const editInvoiceNotes = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/update_invoice_notes/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const editMemberFee = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/update_member_fee/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const createInvoiceNotes = async (payload: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/create_invoice_notes/`,
      payload
    );
    return data;
  } catch (error) {}
};

const api = {
  getMembershipInvoice,
  editPayment,
  getEventInvoice,
  getMembershipInvoiceInfo,
  getInvoiceNote,
  getMemberFees,
  editInvoiceNotes,
  editMemberFee,
  createInvoiceNotes,
};
export default api;
